import { render, staticRenderFns } from "./Sampling.vue?vue&type=template&id=6d18d574&scoped=true"
import script from "./Sampling.vue?vue&type=script&lang=js"
export * from "./Sampling.vue?vue&type=script&lang=js"
import style0 from "./Sampling.vue?vue&type=style&index=0&id=6d18d574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18d574",
  null
  
)

export default component.exports